// JavaScript Document
const version = '20181029'

var templeList = {
	lead: '「色が美しい」「木の肌が自然志向の感覚にフィットする」と、<br class="no-sm">　春慶塗りに再び注目が集まっています。',
	examples: [
		{
			name: '浄名院',
			sub: '平成30年3月完成',
			image: '01.jpg',
			text: '都心の喧騒からは想像できない豊かな緑と静寂さ。上野公園の近くに位置する「浄名院」は、江戸時代から続く江戸六地蔵をはじめとし、八万四千体地蔵をめざす名刹です。<br>このたび納骨堂参拝室や地蔵尊奉納壇を内包する上野さくら浄苑の建設にあたって、従来の黒漆とは異なる、飛騨春慶を基調とした祭壇、仏具でご修復させていただきました。<br><br>東京都台東区上野桜木２丁目６番４号',
			detail: {
				lead: '光を当てると漆を通して木目が黄金色を放つ。',
				items: [
					{ image: '01.jpg', text: '浄名院は上野寛永寺36坊のひとつです。車の往来から山門を抜けると、境内は驚くほど静かな佇まいです。' },
					{ image: '02.jpg', text: '春には桜並木も楽しむことができるくつろぎスペース。' },
					{ image: '03.jpg', text: '地蔵信仰が篤い浄名院には広い境内に二万六千躰の石地蔵尊もが埋め尽くされています。' },
					{ image: '04.jpg', text: '副本堂は春慶調の色に統一しました。' },
					{ image: '05.jpg', text: '' },
					{ image: '06.jpg', text: '阿弥陀様の周辺の瓔珞や仏具は黄金色に輝き、背面の金紙に施された彩色の散蓮（ちりれん）とあいまって、荘厳な雰囲気の中にも艶やかさを演出しています。' },
					{ image: '07.jpg', text: '椅子式の式衆机' },
					{ image: '08.jpg', text: '曲録の金具は衣にひかからないように仕上げました。' },
					{ image: '09.jpg', text: '' },
					{ image: '10.jpg', text: '春慶色に会う色の木魚布団を作らせていただきました。' },
					{ image: '11.jpg', text: '一部仏具は可動式です。' },
					{ image: '12.jpg', text: '仏台には耐震対応を施し、仏様が倒れないように工夫をいたしました。' },
					{ image: '13.jpg', text: '五千体を超える地蔵尊像が安置されています。' },
				]
			}
		},
		{
			name: '智福寺',
			sub: '平成30年3月完成',
			image: '02.jpg',
			text: 'モダンさにくわえ、四季の表情が感じられるよう窓を多用。<br>中は開放感と明るさに溢れ、高齢者の方にもやさしいバリアフリーとなっています。<br>二階の本堂は外観からは想像できない、和の風合いを備えた美しい空間で、飛騨の春慶塗りの仏具と、まばゆい黄金の天蓋の組み合わせは、じつに美しくマッチしています。<br><br><br class="no-sm">東京都練馬区上石神井４丁目9-26',
			detail: {
				lead: '大切に使い込むほどに、その光沢がますます増していく。',
				items: [
					{ image: '01.jpg', text: '溜め色御内陣荘厳' },
					{ image: '02.jpg', text: '修復をした導師机' },
					{ image: '03.jpg', text: '新規製作の木魚台' },
					{ image: '04.jpg', text: '新本堂用に新調した幢幡瓔珞' },
					{ image: '05.jpg', text: '' },
					{ image: '06.jpg', text: '椅子式の式衆机' },
					{ image: '07.jpg', text: '玉斎木魚' },
					{ image: '08.jpg', text: '特注人天蓋' },
					{ image: '09.jpg', text: '隅切りの型が特徴的です。' },
					{ image: '10.jpg', text: '前机の彫刻のデザインにあわせた須弥壇の彫刻' },
					{ image: '11.jpg', text: '新規に製作させていただいた香卓' },
					{ image: '12.jpg', text: '洗濯修復し、新品同様に生まれ変わった前机。' },
					{ image: '13.jpg', text: '' },
					{ image: '14.jpg', text: '新規に製作させていただいた須弥壇。' },
				]
			}
		},
	]
}

var ihaiList = [
	{
		name_ja: '上塗春日',
		name_en: 'Jyo-nuri Kasuga',
		text_ja: 'もっともシンプルな形状で受け台が四角です。<br>上塗（じょうぬり）仕上げにより、美しく高級感のあるお位牌です。',
		text_en: 'Kasuga has the simplest shape with a square cradle under, applying to a finishing coat to create high-grade feel and beauty.',
		image: '01.jpg',
		items: [
			{ id: '100', s: 3.0, h: 15.0, w: 6.0, d: 3.0, price: 17380 },
			{ id: '101', s: 3.5, h: 17.0, w: 6.5, d: 3.5, price: 17380 },
			{ id: '102', s: 4.0, h: 19.3, w: 7.0, d: 4.0, price: 18260 },
			{ id: '103', s: 4.5, h: 21.3, w: 7.5, d: 4.5, price: 18920 },
			{ id: '104', s: 5.0, h: 23.4, w: 8.0, d: 5.0, price: 19800 },
			{ id: '105', s: 5.5, h: 25.4, w: 8.5, d: 5.5, price: 22660 },
		]
	},
	{
		name_ja: '上塗蓮付き春日',
		name_en: ' Jyo-nuri Ren tsuki Kasuga',
		text_ja: '上塗り位牌は、呂色仕上げの美しい鏡面のような質感が特徴です。<br>塗り師が手間ひまをかけて丹念に仕上げたお位牌です。<br>蓮付春日は春日より進化した形で。蓮華台座はとても人気があります。',
		text_en: 'Jyo-nuri Ihai（Buddhist mortuary tablet）features the texture like a beautiful surface of a mirror finished in special japanese lacquer “roiro”.Lacquer-painting craftsmen spend time and effort on this type of Ihai elavolately.Ren-tsuki Kasuga has a more advanced shape than Kasuga.Renge-daiza is very popular.',
		image: '02.jpg',
		items: [
			{ id: '200', s: 3.0, h: 15.0, w: 6.0, d: 3.0, price: 18920 },
			{ id: '201', s: 3.5, h: 17.0, w: 6.5, d: 3.5, price: 18920 },
			{ id: '202', s: 4.0, h: 19.3, w: 7.0, d: 4.0, price: 19800 },
			{ id: '203', s: 4.5, h: 21.3, w: 7.5, d: 4.5, price: 20460 },
			{ id: '204', s: 5.0, h: 23.4, w: 8.0, d: 5.0, price: 21780 },
			{ id: '205', s: 5.5, h: 25.4, w: 8.5, d: 5.5, price: 25740 },
		]
	},
	{
		name_ja: '上塗り猫丸',
		name_en: 'Jyo-nuri Neko-maru',
		text_ja: '金箔による装飾と共に丸みを帯びた台座部分が特徴で、仕上げは繊細な加飾により醸し出されています。<br>上塗仕上げが一層引き立ちます。',
		text_en: 'Jyo-nuri Neko-maru features its rounded plinth “diaza” pedestal with the decoration covered with gold leaf. The delicate decoration gives it a more luxurious feel and makes “Jyo-nuri” finish-coating appear much better.',
		image: '03.jpg',
		items: [
			{ id: '300', s: 3.0, h: 15.0, w: 6.0, d: 3.0, price: 29700 },
			{ id: '301', s: 3.5, h: 17.0, w: 6.5, d: 3.5, price: 30360 },
			{ id: '302', s: 4.0, h: 19.3, w: 7.0, d: 4.0, price: 35640 },
			{ id: '303', s: 4.5, h: 21.3, w: 7.5, d: 4.5, price: 39820 },
			{ id: '304', s: 5.0, h: 23.4, w: 8.0, d: 5.0, price: 45320 },
			{ id: '305', s: 5.5, h: 25.4, w: 8.5, d: 5.5, price: 49720 },
		]
	},
	{
		name_ja: '上京型千倉',
		name_en: ' Jyo-nuri gata  Chikura',
		text_ja: '京型位牌を代表する「千倉」（ちくら）は、金箔部分と黒塗り部分の配分が伝統的な美しさを感じさせます。<br>職人の技術とこだわりが、台座部分の装飾にしっかりと生きています。',
		text_en: 'The distribution of the part lacquered black and the gilded part ref lects a traditional beauty. The decoration of the “diaza” shows certainly the craftsmen’s excellent technique and their craftsmanship.',
		image: '04.jpg',
		items: [
			{ id: '400', s: 3.0, h: 15.0, w: 6.0, d: 3.0, price: 28160 },
			{ id: '401', s: 3.5, h: 17.0, w: 6.5, d: 3.5, price: 29260 },
			{ id: '402', s: 4.0, h: 19.3, w: 7.0, d: 4.0, price: 30800 },
			{ id: '403', s: 4.5, h: 21.3, w: 7.5, d: 4.5, price: 32340 },
			{ id: '404', s: 5.0, h: 23.4, w: 8.0, d: 5.0, price: 35200 },
			{ id: '405', s: 5.5, h: 25.4, w: 8.5, d: 5.5, price: 38500 },
		]
	},
]

var architectList = [
	{
		title: '仏具設計・製作',
		sub: '浄名院',
		image: {},
		text: '光りあふれるやすらぎの場でご先祖供養を。',
		container: 'zigzag-container',
		items: [
			{ image: { src: 'img/08.jpg', width: 475 }, text: '従来の黒漆とは異なる透き漆は、やわらかなコントラストを演出します。' },
			{ image: { src: 'img/09.jpg', width: 485 }, text: '' },
			{ image: { src: 'img/10.jpg', width: 279 }, text: '' },
			{ image: { src: 'img/11.jpg', width: 298 }, text: '面ではなくストライプ仕様で、金色にやわらなな表情をもたせました。' },
			{ image: { src: 'img/12.jpg', width: 378 }, text: '' },
		]
	},
	{
		title: '納骨堂・仏具／設計製作',
		sub: '桂峯寺',
		image: { src: 'img/13.jpg', width: 250 },
		text: '皆様の思いやご事情にあわせて、誠心誠意対応いたします。<br>みなさまの心に寄り添ってお応えできるよう、より良いかたちを一緒に考えさせていただきます。',
		container: 'alternate-container',
		items: [
			{ image: { src: 'img/14.jpg', class: 'margin-top-minus-100' }, text: '' },
			{ image: { src: 'img/15.jpg' }, text: '' },
			{ image: { src: 'img/16.jpg' }, text: '黒漆を中心に、金を要所要所にポイントに<br class="no-sm">使っています。' },
			{ image: { src: 'img/17.jpg' }, text: '' },
			{ image: { src: 'img/18.jpg' }, text: '' },
			{ image: { src: 'img/19.jpg' }, text: '山の中の納骨堂ですが、気品と格調ある空間づくりを創出しました。' },
			{ image: { src: 'img/20.jpg' }, text: '' },
		]
	},
	{
		title: '住宅（ご住職ご家族）／設計・監理施工',
		sub: '',
		image: { src: 'img/21.jpg', width: 250 },
		text: '寺院・庫裏・洋／和風住宅など<br class=no-sm">設計から工事監理まで、<br class="no-sm">お客様の声をカタチにしていきます。',
		container: 'alternate-container',
		items: [
			{ image: { src: 'img/22.jpg', class: 'margin-top-minus-100' }, text: '' },
			{ image: { src: 'img/23.jpg' }, text: 'シンプルテイストのナチュラルなインテリアの<br class="no-sm">ダイニングです。' },
			{ image: { src: 'img/24.jpg' }, text: '' },
			{ image: { src: 'img/25.jpg' }, text: '「うち」が持つプライベート感と、「そと」の開放感。戸建てならではの空間です。' },
			{ image: { src: 'img/26.jpg' }, text: '' },
		]
	},
]



var app = new Vue({
	el: '#app',
	data: {
		templeList: templeList,
		architectList: architectList,
		pageIndex: 0,
		ihaiList: ihaiList,
		form: {},
		inquiry: {
			name: '',
			kana: '',
			mail: '',
			tel: '',
			type: '',
			zip: '',
			addr: '',
			msg: '',
			step: 0,
			status: '',
			result: '',
			code: ''
		}
	},
	computed: {
		architectData() {
			return this.templeList.examples[this.pageIndex]
		},
		imageDir: function () {
			return `${`000${this.pageIndex}`.slice(-3)}/`
		},
		checkInquiryForm() {
			return (this.inquiry.name == '') || (this.inquiry.kana == '') || (this.inquiry.mail == '') || (this.inquiry.tel == '') || (this.inquiry.msg == '')
		}
	},
	methods: {
		go(url) {
			location.href = url
		},
		inquiryConfirm() {
		},
		postInquery() {
			axios.put('/api/mail.php', this.inquiry).then((res) => {
				this.inq.step = 2
				this.inq.status = res.data.status
				this.inq.result = res.data.result
				this.inq.code = res.data.code
			})
		}
	}
})
